import * as React from 'react';

import type { VariantProps } from 'tailwind-variants';
import { tv } from 'tailwind-variants';

import { cn, getRandomColor } from '@avodah-inc/ui/utils';

import { Avatar } from '../../atoms/avatar';

const avatarGroupVariants = tv({
  base: 'flex justify-center items-center w-fit',
});

export type AvatarGroupProps = React.HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof avatarGroupVariants> & {
    avatars?: { initials: string; image?: string | null; id: string }[];
  };

export const AvatarGroup = React.forwardRef<HTMLDivElement, AvatarGroupProps>(
  ({ className, avatars = [], ...props }, ref) => {
    const limitedAvatars = avatars.slice(0, 5);
    return (
      <div
        className={cn(
          avatarGroupVariants({
            className,
          }),
        )}
        ref={ref}
        {...props}
      >
        {limitedAvatars.map((avatar, index) => (
          <div
            className={cn({
              'ml-0': index === 0,
              'ml-[-5px]': index !== 0,
              [`z-${limitedAvatars.length - index - 1}`]: true,
            })}
          >
            <Avatar
              key={index}
              size="xs"
              initials={avatar.initials}
              src={avatar.image ?? ''}
              alt={`Avatar group image #${index}`}
              backgroundColor={`bg-${getRandomColor(avatar.id)}`}
              style={{
                zIndex: limitedAvatars.length - index - 1,
              }}
            />
          </div>
        ))}
      </div>
    );
  },
);

AvatarGroup.displayName = 'AvatarGroup';
